import ProfileBgSVG from 'assets/ver2/icons/profile-bg.svg';
import { getFirstNameLastName } from 'components/common/func';
import useStore from 'hooks/useStore';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';

const Avatar = () => {
  const { state } = useStore();
  const { currentUser } = state;
  const { firstName, lastName } = currentUser || {};

  return (
    <AvatarStyled>
      <Text>Hello,</Text>
      <AvatarName>
        {getFirstNameLastName({
          firstName,
          lastName,
        })}
      </AvatarName>
    </AvatarStyled>
  );
};

const AvatarStyled = styled.div`
  position: relative;
  background-image: url(${ProfileBgSVG});
  width: calc(100% + 32px);
  margin: -16px;
  padding: 28px 16px;
`;

const AvatarName = styled.p`
  ${paragraphMixin};
  font-size: 24px;
  line-height: 30px;
  text-transform: uppercase;
  color: #fff;
  margin: 0;
  padding: 0;
  padding-bottom: 52px;
`;

const Text = styled.p`
  ${paragraphMixin};
  font-weight: 500;
  color: #fff;
  margin: 0;
  padding: 0;
`;

export default Avatar;
